/** A list read (`{ items }` or a plain array) with nothing in it: the one-item space has no item yet. */
export const isEmptyList = (page: unknown): boolean => {
  const items = Array.isArray(page) ? page : (page as { items?: unknown[] } | null)?.items ?? []
  return items.length === 0
}
